export default "__VITE_ASSET__TCijOsWP__"